import type { ReactNode } from 'react'

import { Alert, AlertDescription } from '@/components/ui/alert'

export interface EarlyAccessBannerProps {
  className?: string
}

export const EarlyAccessBanner = ({ className }: EarlyAccessBannerProps): ReactNode => (
  <Alert className={className}>
    <AlertDescription>
      Early access — full Pro features are unlocked while we finalize subscriptions.
    </AlertDescription>
  </Alert>
)

EarlyAccessBanner.displayName = 'EarlyAccessBanner'
